import {
  create,
  read
} from 'src/api/http'
import { UrlUtils } from 'src/utils/url/url'

import * as decoder from 'src/api/decoders'
import * as encoder from 'src/api/encoders'
import * as PATH from 'src/constants/urls'

export interface IPaginationParams {
  page?: number;
  perPage?: number;
  orderBy?: string;
  sortBy?: string;
}

interface IMailboxMessagesParams extends IPaginationParams {
  conversationId: string;
}

interface ISendMessageParams {
  body?: string;
  conversationId: string;
  images?: string[];
  linkPreviewUrl?: string;
}

interface IConversationParams {
  conversationId: string;
}

interface ICreateConversationParams {
  profileType: string;
  profileId: string;
}

export interface IOAuth2LoginParams {
  email: string;
  password: string;
}

export interface IOAuth2LogoutParams {
  token: string;
}

export interface IOAuth2RefreshParams {
  refreshToken: string;
}

export interface IRegistrationParams extends IOAuth2LoginParams {
  preRegistrationToken?: string;
}

export default {
  mailbox: {
    conversation: (params: IConversationParams) => {
      return (read(`${PATH.API_CONVERSATIONS_PATH}${params.conversationId}/`, decoder.$conversationResponse))
    },
    conversations: (params: IPaginationParams) => {
      return (read(PATH.API_CONVERSATIONS_PATH, decoder.$conversations, encoder.$pagination(params)))
    },
    createConversation: (params: ICreateConversationParams) =>
      create(
        PATH.API_CONVERSATIONS_PATH,
        encoder.$conversationCreate(params.profileType, params.profileId),
        decoder.$conversationCreate
      ),
    createMessage: (params: ISendMessageParams) =>
      create(
        `${PATH.API_CONVERSATIONS_PATH}${params.conversationId}/messages`,
        encoder.$messageCreate(params.body, params.images, params.linkPreviewUrl),
        decoder.$messageCreate
      ),
    messages: (params: IMailboxMessagesParams) => {
      const path = `${PATH.API_CONVERSATIONS_PATH}${params.conversationId}/messages`
      return (read(path, decoder.$conversationMessages, encoder.$conversationMessage(params)))
    }
  },

  oauth2: {
    login: (params: IOAuth2LoginParams) =>
      create(PATH.OAUTH2_TOKEN_PATH, encoder.$oauth2Login(params), decoder.$oauth2Credentials),
    refresh: (params: IOAuth2RefreshParams) =>
      create(PATH.OAUTH2_TOKEN_PATH, encoder.$oauth2Refresh(params), decoder.$oauth2Credentials)
  },

  profile: {
    resendConfirmationEmail: () => {
      const redirectUrl = UrlUtils.emailConfirmationRedirectUrl()
      return create(
        PATH.API_USER_RESEND_CONFIRMATION_EMAIL,
        encoder.$resendConfirmationEmail(redirectUrl),
        decoder.$noop
      )
    }
  }
}
